import { makeStyles } from '@material-ui/core';
import DocumentSignIcon from '../assets/images/document-sign-icon.svg?react';
import { DocumentData } from '../providers/FormProvider';
import Button from './Button';
import Loading from './Loading';
import Modal from './Modal';
import PdfViewer from './PdfViewer';

const useStyles = makeStyles((theme) => ({
  documentWrapper: {
    margin: '24px 0 24px',
    display: 'inline-flex',
    gap: 12,
    flex: '0 0 auto',
  },
  icon: {
    color:
      theme.palette.type === 'light' ? theme.palette.common.midBlue : '#fff',
    fill:
      theme.palette.type === 'light' ? theme.palette.common.midBlue : '#fff',
  },
}));

export interface DocumentProps {
  id: string;
  label?: string;
  modal: boolean;
  name: string;
  data: DocumentData | null;
  loading?: boolean;
  lowercase?: boolean;
  closeModal: () => void;
  handleClick: () => void;
}

function Document({
  closeModal,
  data,
  handleClick,
  label,
  loading = false,
  modal,
  name,
  lowercase = false,
}: DocumentProps) {
  const classes = useStyles();

  return (
    <>
      <Button
        variant="tertiary"
        disabled={loading}
        onClick={handleClick}
        data-testid="document-view-button"
      >
        {label ?? `View ${lowercase ? name.toLowerCase() : name}`}
        <DocumentSignIcon className={classes.icon} />
      </Button>

      {modal && (loading || data?.file) && (
        <Modal
          maxWidth="lg"
          open={modal}
          title={data?.title ?? name}
          closeHandler={closeModal}
          dataTestId="document-viewer-modal"
        >
          {data?.file ? (
            <PdfViewer modal file={data.file} name={data.id} />
          ) : (
            <Loading inline />
          )}
        </Modal>
      )}
    </>
  );
}

export default Document;
